import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Row from './row';

export function Users({ users }) {
  const orderedUsers = [...users.filter(user => !user.disabled), ...users.filter(user => user.disabled)];
  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr className="text-nowrap">
            <th>Broker Name</th>
            <th>Assigned To</th>
            <th>Default Plan</th>
          </tr>
        </thead>
        <tbody>
          {orderedUsers.map(user => <Row key={user.id} user={user} />)}
        </tbody>
      </table>
    </div>
  );
}

Users.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
};

const mapStateToProps = state => ({
  users: state.users,
});

export default connect(mapStateToProps)(Users);
